import { BadRequestError, ForbiddenError, NoContentError, InternalServerError, UnauthorizedError, UnknownError, GatewayTimeoutError, ConflictError, BadGatewayError } from "~/abstractions/errors";
import { eventBus } from "~/abstractions/event-bus";

export default (function (_ref, inject) {
  var $axios = _ref.$axios,
      store = _ref.store;

  $axios.defaults.timeout = 1000 * 60 * 5;
  $axios.onRequest(function (config) {
    config.validateStatus = function (status) {
      return true;
    };
    config.timeout = 1000 * 60 * 5;
    var token = store.state.user.token;


    if (token) config.headers.common["Authorization"] = "Bearer " + token;

    return config;
  });

  $axios.onResponse(function (response) {
    var data = response.data,
        status = response.status;


    switch (status) {
      case 200:
      case 201:
        return response;
      case 204:
        throw new NoContentError();
      case 400:
        console.log(status, data);
        throw new BadRequestError(data);
      case 401:
        eventBus.$emit("logout");
        throw new UnauthorizedError();
      case 403:
        throw new ForbiddenError();
      case 409:
        throw new ConflictError(data);
      case 500:
        // console.log(status, data)
        throw new InternalServerError(data);
      case 502:
        throw new BadGatewayError();
      case 504:
        throw new GatewayTimeoutError();
      default:
        throw new UnknownError(status, data);
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/axios.js
// module id = ./src/plugins/axios.js
// module chunks = 34